@switch (data.animation) {
  @case (notificationType.ERROR) {
    <cgw-error-animation />
  }
  @case (notificationType.SUCCESS) {
    <cgw-success-animation />
  }
}
<div class="message mb-3 text-center">
  {{ data.message }}
</div>
<button
  mat-flat-button
  color="primary"
  (click)="continue()">
  Continuar
</button>
